$(window).on('load scroll', function() {
    // スクロールアニメーション
    var slideLeft = $('.js-slide-left');
    var slideRight = $('.js-slide-right');
    var fadeLeft = $('.js-fade-left');
    var fadeRight = $('.js-fade-right');
    var fadeIn = $('.js-fade-in');
    var wh = $(window).height();
    var scrollPos = $(window).scrollTop();

    // 左からスライドイン
    slideLeft.each(function() {
        var SlideLeftPlay = 'SlideLeftPlay';
        var slideLeftOffset = $(this).offset().top;
        if (scrollPos > slideLeftOffset - wh) {
            $(this).addClass(SlideLeftPlay);
        }
    });
    // 右からスライドイン
    slideRight.each(function() {
        var SlideRightPlay = 'SlideRightPlay';
        var slideRightOffset = $(this).offset().top;
        if (scrollPos > slideRightOffset - wh) {
            $(this).addClass(SlideRightPlay);
        }
    });
    // 左からフェードイン
    fadeLeft.each(function() {
        var fadeLeftPlay = 'fadeLeftPlay';
        var fadeLeftOffset = $(this).offset().top;
        if (scrollPos > fadeLeftOffset - wh) {
            $(this).addClass(fadeLeftPlay);
        }
    });
    // 右からフェードイン
    fadeRight.each(function() {
        var fadeRightPlay = 'fadeRightPlay';
        var fadeRightOffset = $(this).offset().top;
        if (scrollPos > fadeRightOffset - wh) {
            $(this).addClass(fadeRightPlay);
        }
    });
    // フェードイン
    fadeIn.each(function() {
        var fadePlay = 'fadePlay';
        var fadeInOffset = $(this).offset().top;
        if (scrollPos > fadeInOffset - wh) {
            $(this).addClass(fadePlay);
        }
    })
});


// クーポンコードコピー
$(function() {
    $('#js-code').click(function() {
        const url = $(this).data('code');
        navigator.clipboard.writeText(url);
        $('.p-coupon__msg').fadeIn("fast", function() {
            $(this).delay(2000).fadeOut("fast");
        });
    });
});

// 続きを読むボタン
const itemHeights = [];
let returnHeight;
$(function() {
    $(".js-accordion-txt").each(function() {
        const thisHeight = $(this).height();
        itemHeights.push(thisHeight);
        $(this).addClass("is-hide");
        returnHeight = $(this).height();
    });
});

$(".js-accordion-btn").click(function() {
    if (!$(this).hasClass("is-show")) {
        const index = $(this).index(".js-accordion-btn");
        const addHeight = itemHeights[index];
        $(this)
            .addClass("is-show")
            .prev()
            .animate({ height: addHeight }, 300)
    } else {
        $(this)
            .removeClass("is-show")
            .prev()
            .animate({ height: returnHeight }, 300)
    }
});

const createSrc = (src, lang, text) => {
    const array = src.srcset.split(`.${text}`)
    src.srcset = `${array[0]}_${lang}.${text}${array[1]}`
}


//画像翻訳用
const changeImage = () => {
    let lang = document.querySelector('html').lang
    if (lang.includes('en')) {
        return false
    } else {
        const target = document.querySelectorAll('[data-translate-img] source')
        target.forEach((value) => {
            if (value.srcset.includes(lang)) {
                return false
            } else {
                if (value.srcset.includes('jpg')) {
                    createSrc(value, lang, 'jpg')
                    return false
                } else if (value.srcset.includes('png')) {
                    createSrc(value, lang, 'png')
                    return false
                } else if (value.srcset.includes('svg')) {
                    createSrc(value, lang, 'svg')
                    return false
                }
            }
        })
    }
}

window.addEventListener('DOMContentLoaded', () => {
    if (document.querySelectorAll('[data-translate-img]')) {
        changeImage()
    }
})